module.exports = __webpack_public_path__ + "static/media/7_The PIER-2 ART CENTER - Kaohsiung.f9e32164.jpg";